export default __webpack_public_path__ + "static/media/nsm.11a77a44.jpg";